import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { CatalogCharacteristicObject } from './../../../models/catalog/catalog-characteristic-object.model';
import { Converter } from './../converter.interface';

@Injectable({
  providedIn: 'root'
})

export class CatalogCharacteristicsObjectConverter implements Converter<CatalogCharacteristicObject> {

  convert(input: any): CatalogCharacteristicObject {

    if (isNullOrUndefined(input)) {
      return CatalogCharacteristicObject.create();
    }

    return new CatalogCharacteristicObject(input.namingId, input.name, input.type, input.out);

  }

}
